<div class="d-flex flex-column gap-3" data-testid="payment-table-panel">
  <h3 class="av-section-title m-0">{{ 'backoffice.billing.payments.title' | translate }}</h3>

  @switch (facade.paymentsState()) {
    @case ('error') {
      <av-empty-state
        icon="error_outline"
        [title]="'backoffice.billing.payments.error_title' | translate"
        [message]="'backoffice.billing.payments.error_message' | translate"
      ></av-empty-state>
    }
    @case ('ready') {
      <div class="filter-row d-flex flex-wrap align-items-end gap-2">
        <label class="d-flex flex-column gap-1" for="payment-status">
          <span class="av-meta">{{ 'backoffice.billing.payments.filters.status' | translate }}</span>
          <select
            id="payment-status"
            class="av-field"
            [value]="facade.paymentStatus()"
            (change)="filterStatus($any($event.target).value)"
            data-testid="payment-status-filter"
          >
            <option value="">{{ 'backoffice.billing.payments.filters.any_status' | translate }}</option>
            @for (option of statusOptions; track option) {
              <option [value]="option">{{ statusLabelKeys[option] | translate }}</option>
            }
          </select>
        </label>
      </div>

      @if (isEmpty()) {
        <av-empty-state
          icon="payments"
          [title]="
            (facade.paymentStatus()
              ? 'backoffice.billing.payments.filtered_empty_title'
              : 'backoffice.billing.payments.empty_title'
            ) | translate
          "
          [message]="
            (facade.paymentStatus()
              ? 'backoffice.billing.payments.filtered_empty_message'
              : 'backoffice.billing.payments.empty_message'
            ) | translate
          "
        ></av-empty-state>
      } @else {
        <p class="av-meta m-0" data-testid="refund-scope-note">{{ 'backoffice.billing.refunds.only_on_succeeded' | translate }}</p>

        <div class="table-scroll">
          <table class="av-table w-100" data-testid="payment-table">
            <thead>
              <tr>
                <th scope="col">{{ 'backoffice.billing.payments.table.payment' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.payments.table.status' | translate }}</th>
                <th scope="col" class="text-end">{{ 'backoffice.billing.payments.table.amount' | translate }}</th>
                <th scope="col" class="text-end">{{ 'backoffice.billing.payments.table.refunded' | translate }}</th>
                <th scope="col" class="text-end">{{ 'backoffice.billing.payments.table.refundable' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.payments.table.failure' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.payments.table.created' | translate }}</th>
                <th scope="col"></th>
              </tr>
            </thead>

            <tbody>
              @for (payment of facade.payments(); track payment.id) {
                <tr>
                  <td class="av-source">{{ payment.stripe_payment_intent_id || unresolved }}</td>

                  <td>
                    <av-status-chip
                      [label]="payment.statusLabelKey | translate"
                      [tone]="payment.statusTone"
                    ></av-status-chip>
                  </td>

                  <td class="text-end">
                    {{ payment.amount === null ? unresolved : (payment.amount | number: '1.2-2') }}
                    {{ payment.currency || '' }}
                  </td>

                  <td class="text-end" data-testid="payment-refunded">
                    {{ payment.refunded_amount | number: '1.2-2' }}
                  </td>

                  <td class="text-end" data-testid="payment-refundable">
                    {{ payment.refundable_remainder | number: '1.2-2' }}
                  </td>

                  <td class="cell-muted">
                    {{ payment.failure_message || payment.failure_code || unresolved }}
                  </td>

                  <td class="cell-muted">
                    {{ payment.created_at ? (payment.created_at | date: dateTimeFormat) : unresolved }}
                  </td>

                  <td>
                    <div class="d-flex gap-2">
                      <button
                        type="button"
                        class="av-btn"
                        [disabled]="!facade.canWrite() || !payment.is_retryable"
                        [matTooltip]="
                          payment.is_retryable
                            ? ''
                            : ('backoffice.billing.payments.retry_unavailable' | translate)
                        "
                        (click)="openRetry(payment)"
                        data-testid="payment-retry"
                      >
                        {{ 'backoffice.billing.payments.retry' | translate }}
                      </button>

                      <button
                        type="button"
                        class="av-btn"
                        [disabled]="!facade.canWrite() || !payment.isRefundable"
                        [matTooltip]="
                          payment.isRefundable
                            ? ''
                            : ('backoffice.billing.refunds.only_on_succeeded' | translate)
                        "
                        (click)="openRefund(payment)"
                        data-testid="payment-refund"
                      >
                        {{ 'backoffice.billing.payments.refund' | translate }}
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <av-paginator
          [page]="facade.paymentPage()"
          [pageSize]="facade.pageSize()"
          [total]="facade.paymentTotal()"
          (pageChange)="goToPage($event)"
          (pageSizeChange)="changePageSize($event)"
        ></av-paginator>
      }
    }
    @default {
      <av-empty-state
        icon="hourglass_empty"
        [title]="'backoffice.billing.payments.loading_title' | translate"
        [message]="'backoffice.billing.payments.loading_message' | translate"
      ></av-empty-state>
    }
  }
</div>
